export default __webpack_public_path__ + "static/media/Leardini.52b19e22.png";